import { type Viewport } from "reactflow";

export const EXTERNAL_TRIGGER_ITEM_HEIGHT = 44;

export const getDesignerPosition = (getTriggersLength: number = 0, zoom: number = 1): Viewport => {
  const y = getTriggersLength ? (getTriggersLength - 1) * EXTERNAL_TRIGGER_ITEM_HEIGHT : 0;
  return { x: 0, y, zoom };
};
